const radarData = {
  color: ['#67F9D8', '#FFE434', '#56A3F1', '#FF917C'],
  title: {
    text: ''
  },
  legend: {},
  radar: [
    {
      indicator: [
        { text: '主食' },
        { text: '蔬菜' },
        { text: '油脂' },
        { text: '蛋白质' },
        { text: '饮食搭配' }
      ],
      center: ['50%', '55%'],
      radius: 110,
      startAngle: 162,
      splitNumber: 5,
      shape: 'circle',
      nameGap: 6,
      axisName: {
        fontSize: 14,
        color: 'rgba(0,0,0,0.5)'
      },
      splitArea: {
        areaStyle: {
          color: [
            'rgba(98, 54, 255, 0.48)',
            'rgba(98, 54, 255, 0.38)',
            'rgba(98, 54, 255, 0.28)',
            'rgba(98, 54, 255, 0.18)',
            'rgba(98, 54, 255, 0.08)'
          ],
          shadowColor: 'rgba(0, 0, 0, 0.2)',
          shadowBlur: 10
        }
      },
      axisLine: {
        lineStyle: {
          width: 3,
          color: 'rgb(240, 245, 255)'
        }
      },
      splitLine: {
        lineStyle: {
          color: 'rgba(0, 0, 0, 0)'
        }
      }
    }
  ],
  series: [
    {
      type: 'radar',
      emphasis: {
        lineStyle: {
          width: 4
        }
      },
      label: {
        show: true,
        color: '#6236ff'
      },
      data: []
    }
  ]
}
export { radarData }
